

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";


  
// Inizializzare GSAP e ScrollTrigger
gsap.registerPlugin(ScrollTrigger);


// Seleziona tutti gli elementi con la classe .immagine-sfondo
gsap.utils.toArray(".immagine-sfondo").forEach(function (elem) {
    const parentElem = elem.parentElement; 

    if (parentElem) {
        const tl = gsap.timeline();

        // fade in
        tl.to(elem, { opacity: 1, stagger: 1 });
        // fade out
        tl.to(elem, { opacity: 0, stagger: 1 }, 1);

        ScrollTrigger.create({
            animation: tl,
            trigger: parentElem, // Usa il parent come trigger
            start: 'top 70%',
            end: 'bottom 30%',
            scrub: 0.1,
            // markers: true, // Opzionale per il debug
        });
    }
});
